import { styled } from '@mui/material'
import React from 'react'
import { IconType } from 'react-icons/lib'
import { uuidv7 } from 'uuidv7'
import { CtrolType, ICtrl, ICtrlList, ICtrlParam, ICtrlRadio, ICtrlRadioDirection } from './models'

// ICONS
import { BsCalendar2Date as IconDate, } from 'react-icons/bs'
import { MdCheckBox as IconCheckBox, MdTextFields as IconLabel, MdRadioButtonChecked as IconRadioButton } from 'react-icons/md'
import { RxDividerHorizontal as IconDivider, RxText as IconTextField } from 'react-icons/rx'
import { TbPageBreak as IconBreakLine, TbNumbers as IconNumber, TbSelect as IconSelect, } from 'react-icons/tb'

const CtrlParamsToolsItemWrapperStyled = styled('div')(({ theme }) => ({
  padding: 5,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'hidden',
  ':hover': {
    'background': '#ECECED',
    'color': theme.palette.getContrastText('#ECECED')
  },
  borderRadius: 4
}))

interface CtrlParamsToolsItemComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  icon: IconType,
  label?: string,
}

const CtrlParamsToolsItemComponent = (props: CtrlParamsToolsItemComponentProps) => {
  const { label, icon, ...rest } = props

  return <CtrlParamsToolsItemWrapperStyled
    {...rest}
  >
    {<props.icon size={20}></props.icon>}
    <label style={{ fontSize: 10, textAlign: 'center', }}>{props?.label}</label>
  </CtrlParamsToolsItemWrapperStyled>
}

export interface CtrlParamsToolsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  onClickItem?: (ctrl: ICtrl) => void
}

export const CtrlParamsToolsComponent = (props: CtrlParamsToolsComponentProps) => {
  const { onClickItem, ...rest } = props

  return <div
    {...rest}
    className={`${props.className}${'leftContainerComponent'}`}
    style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 10, ...props.style, }}
  >
    <CtrlParamsToolsItemComponent
      icon={IconLabel} label='Label'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.label,
            label: 'Digite algum texto na propriedade label desse componente'
          } as ICtrlParam)
      }}>
    </CtrlParamsToolsItemComponent>

    <CtrlParamsToolsItemComponent
      icon={IconTextField} label='Texto'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.text
          } as ICtrlParam)
      }}>
    </CtrlParamsToolsItemComponent>

    <CtrlParamsToolsItemComponent
      icon={IconNumber} label='Número'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.num
          } as ICtrlParam)
      }}>
    </CtrlParamsToolsItemComponent>


    <CtrlParamsToolsItemComponent
      icon={IconDate} label='Data'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.date
          } as ICtrlParam)
      }}>
    </CtrlParamsToolsItemComponent>

    <CtrlParamsToolsItemComponent
      icon={IconCheckBox} label='Verd/falso'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.check
          } as ICtrlParam)
      }} />

    <CtrlParamsToolsItemComponent
      icon={IconRadioButton} label='Multiplas opcões'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.radio,
            items: [{
              uuid: uuidv7(),
              label: 'Escolha um título para a opção',
              value: 'valor_da_opcao_1'
            }],
            direction: ICtrlRadioDirection.horizontal
          } as ICtrlRadio)
      }} />

    <CtrlParamsToolsItemComponent
      icon={IconSelect} label='Multiplas opções lista'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.select,
            items: [{
              uuid: uuidv7(),
              label: 'Título da opção',
              value: 'valor_da_opcao'
            }]
          } as ICtrlList)
      }} />

    <CtrlParamsToolsItemComponent
      icon={IconDivider} label='Linha divisora'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.divider
          })
      }} />

    <CtrlParamsToolsItemComponent
      icon={IconBreakLine} label='Quebra de linha'
      onClick={() => {
        if (props?.onClickItem)
          props.onClickItem({
            uuid: uuidv7(),
            type: CtrolType.break
          })
      }} />
  </div>
}